module.exports = __webpack_public_path__ + "static/media/7.48836eb5.jpg";